import { makeStyles, Theme } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { FormikPasswordField } from "../../../components/form/Formik";
import FormError from "../../../components/form/Formik/FormError";
import { FormikSubmitButton } from "../../../components/form/Formik/FormikSubmitButton";
import { Layout } from "../../components/Layout";
import { usePasswordRecoveryPage } from "./usePasswordRecoveryPage";

const useStyles = makeStyles(
  (theme: Theme) => ({
    form: {
      display: "flex",
      flexDirection: "column",
    },
    button: {
      alignSelf: "center",
      marginTop: 10,
      [theme.breakpoints.up("xs")]: {
        marginTop: 6,
      },
    },
  }),
  { name: "PasswordRecoveryPage" }
);

export const PasswordRecoveryPage = () => {
  const { formatMessage } = useIntl();
  const { initialValues, validationSchema, onSubmit } = usePasswordRecoveryPage();
  const classes = useStyles();
  const passwordLabel = formatMessage({ id: "passwordRecovery.newPassword" });
  const passwordConfirmationLabel = formatMessage({ id: "passwordRecovery.newPasswordConfirmation" });

  return (
    <Layout title={formatMessage({ id: "passwordRecovery.setNewPassword" })}>
      <Formik onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema}>
        <Form className={classes.form}>
          <FormikPasswordField
            fullWidth
            name="password"
            label={passwordLabel}
            placeholder={passwordLabel}
            InputLabelProps={{ shrink: true }}
          />
          <FormikPasswordField
            fullWidth
            name="passwordConfirmation"
            label={passwordConfirmationLabel}
            placeholder={passwordConfirmationLabel}
            InputLabelProps={{ shrink: true }}
          />
          <FormError />
          <FormikSubmitButton type="submit" className={classes.button}>
            <FormattedMessage id="passwordRecovery.submitButton" />
          </FormikSubmitButton>
        </Form>
      </Formik>
    </Layout>
  );
};
